export default __webpack_public_path__ + "static/media/6.b083baf4.jpg";